import { Grid } from "@mui/material";
import CreatePartnership from "./PartnershipActions/createParnership";
const PartnershipActions = ({
  loading,
  error,
  filters,
  pagination,
  refetchPartnerships,
  createPartnership,
  availablePartnerships,
}) => {
  return (
    <Grid container>
      <CreatePartnership
        createPartnership={createPartnership}
        error={error}
        loading={loading}
        availablePartnerships={availablePartnerships}
      />
    </Grid>
  );
};

export default PartnershipActions;
